/**
 * Simple Product Card - Material Swatch Handler
 * Based on material-swatch-handler.js
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeSimpleCardSwatches();
  });

  function initializeSimpleCardSwatches() {
    // Use event delegation for simple product cards
    document.addEventListener('click', function(e) {
      const swatchBlock = e.target.closest('.spc-prd-swatch-block');
      if (swatchBlock) {
        const productCard = swatchBlock.closest('.simple-prd-card');
        
        if (productCard) {
          e.preventDefault();
          e.stopPropagation();
          handleSwatchClick(swatchBlock, productCard);
        }
      }
    });
  }

  function handleSwatchClick(swatchBlock, productCard) {
    // Check if already active
    if (swatchBlock.classList.contains('spc-prd-swatch-block-ac')) {
      return;
    }

    // Update active swatch immediately
    updateActiveSwatch(productCard, swatchBlock);

    // Get the ORIGINAL product handle (from data-product-handle which never changes)
    const originalHandle = swatchBlock.getAttribute('data-product-handle');
    
    if (!originalHandle) {
      return;
    }

    // Get clicked swatch's materials
    const targetMaterial = swatchBlock.getAttribute('data-material');
    const currentMaterialOfSwatch = swatchBlock.getAttribute('data-current-material');
    
    // Generate new handle by replacing data-current-material with data-material
    const newHandle = originalHandle.replace(currentMaterialOfSwatch, targetMaterial);

    // Show loading state
    showLoadingState(productCard);

    // Fetch product media
    fetchProductMedia(newHandle, productCard, targetMaterial);
  }

  function getCurrentHandle(productCard) {
    // Try to get from product link
    const productLink = productCard.querySelector('.spc-product-title a, .product-link');
    
    if (productLink) {
      const href = productLink.getAttribute('href');
      if (href) {
        const match = href.match(/\/products\/([^?#]+)/);
        if (match) {
          return match[1];
        }
      }
    }

    // Fallback to data attribute
    const swatchWithHandle = productCard.querySelector('.spc-prd-swatch-block[data-product-handle]');
    if (swatchWithHandle) {
      return swatchWithHandle.getAttribute('data-product-handle');
    }

    return null;
  }

  function updateActiveSwatch(productCard, clickedSwatch) {
    // Remove active class from all swatches
    const allSwatches = productCard.querySelectorAll('.spc-prd-swatch-block');
    allSwatches.forEach(swatch => {
      swatch.classList.remove('spc-prd-swatch-block-ac');
    });

    // Add active class to clicked swatch
    clickedSwatch.classList.add('spc-prd-swatch-block-ac');
  }

  function generateNewHandle(currentHandle, currentMaterial, targetMaterial) {
    // Replace material in handle
    // Example: "the-amber-set-with-a-2-5-carat-emerald-14k-rose-gold-moissanite"
    // becomes: "the-amber-set-with-a-2-5-carat-emerald-14k-yellow-gold-moissanite"
    
    if (currentMaterial) {
      return currentHandle.replace(currentMaterial, targetMaterial);
    }

    // Fallback: try to replace common material patterns
    return currentHandle
      .replace(/-14k-white-gold/gi, `-${targetMaterial}`)
      .replace(/-14k-yellow-gold/gi, `-${targetMaterial}`)
      .replace(/-14k-rose-gold/gi, `-${targetMaterial}`)
      .replace(/-white-gold/gi, `-${targetMaterial}`)
      .replace(/-yellow-gold/gi, `-${targetMaterial}`)
      .replace(/-rose-gold/gi, `-${targetMaterial}`);
  }

  function showLoadingState(productCard) {
    const productImg = productCard.querySelector('.spc-product-img');
    if (productImg) {
      productImg.style.transition = 'opacity 0.3s ease';
      productImg.style.opacity = '0.5';
    }
  }

  function hideLoadingState(productCard) {
    const productImg = productCard.querySelector('.spc-product-img');
    if (productImg) {
      productImg.style.opacity = '1';
    }
  }

  function fetchProductMedia(handle, productCard, targetMaterial) {
    const query = `
      query ProductMedia($handle: String!) {
        product(handle: $handle) {
          title
          handle
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          featuredImage {
            url
            altText
          }
          media(first: 50) {
            nodes {
              mediaContentType
              previewImage {
                url
                altText
              }
              ... on MediaImage {
                id
                image {
                  url
                  altText
                }
              }
            }
          }
        }
      }
    `;

    fetch('/api/2025-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.ShopifyStorefrontToken || '5e6dfd90330910f5f49c5d60ecfb4ddf',
      },
      body: JSON.stringify({
        query: query,
        variables: { handle: handle },
      }),
    })
    .then(response => response.json())
    .then(data => {
      if (data.errors) {
        hideLoadingState(productCard);
        return;
      }

      if (data.data && data.data.product) {
        updateProductCard(productCard, data.data.product, targetMaterial);
      } else {
        hideLoadingState(productCard);
      }
    })
    .catch(error => {
      hideLoadingState(productCard);
    });
  }

  function updateProductCard(productCard, productData, targetMaterial) {
    // Update image ONLY with smooth transition
    const productImg = productCard.querySelector('.spc-product-img');
    if (productImg && productData.featuredImage) {
      productImg.style.opacity = '0';
      
      setTimeout(() => {
        productImg.src = productData.featuredImage.url;
        productImg.alt = productData.featuredImage.altText || productData.title;
        productImg.onload = () => {
          productImg.style.opacity = '1';
        };
      }, 150);
    } else {
      hideLoadingState(productCard);
    }

    // Don't update anything else - keep original title, price, and URLs
  }

  // Expose functions globally if needed
  window.SimpleCardSwatchHandler = {
    handleSwatchClick: handleSwatchClick,
    updateActiveSwatch: updateActiveSwatch
  };

})();
